import { MagnifyingGlass } from "@phosphor-icons/react";
import { cva, type VariantProps } from "class-variance-authority";
import { clsx } from "clsx";
import { forwardRef, type InputHTMLAttributes } from "react";

import { getWhitelabelCustomization } from "common/helpers/utils";

const menuSearchInputVariants = cva(
  "w-full placeholder:text-black-500 focus:outline-none",
  {
    variants: {
      sizeVariant: {
        sm: "pl-8 pr-2.5 text-xs-medium py-2",
        md: "pl-10 pr-3.5 text-sm-medium py-2.5",
      },
    },
    defaultVariants: {
      sizeVariant: "md",
    },
  },
);

type MenuSearchInputProps = InputHTMLAttributes<HTMLInputElement> &
  VariantProps<typeof menuSearchInputVariants>;

export const MenuSearchInput = forwardRef<
  HTMLInputElement,
  MenuSearchInputProps
>(({ className, sizeVariant, ...props }, ref) => {
  return (
    <div
      className={clsx(
        "relative flex items-center border-b border-b-black-200 transition-[border]",
        getWhitelabelCustomization()?.primary_color
          ? "has-[input:focus-visible]:border-whitelabel-primary"
          : "has-[input:focus-visible]:border-b-purple-400",
      )}
    >
      <MagnifyingGlass
        className={clsx(
          "pointer-events-none absolute ",
          sizeVariant === "sm" ? "left-2.5 size-4" : "left-3.5 size-5",
        )}
      />
      <input
        placeholder="Search..."
        {...props}
        ref={ref}
        onKeyDown={(e) => {
          e.stopPropagation();
        }}
        className={menuSearchInputVariants({ sizeVariant })}
      />
    </div>
  );
});
MenuSearchInput.displayName = "MenuSearchInput";
